import React from 'react';
import { PublicPage } from '../PublicPage';
import { TEAM_MEMBERS } from './ourTeamContent';

export const OurTeam: React.FC = () => (
  <PublicPage
    title="Meet the Team"
    subtitle="The people behind Facilon."
    icon="bi-people-fill"
  >
    <div className="person-list">
      {TEAM_MEMBERS.map((member) => (
        <article className="person-card" key={member.name}>
          <div className="person-photo">
            <img src={member.photo} alt={member.name} loading="lazy" />
          </div>
          <div className="person-body">
            <h2 className="person-name">
              {member.name}
              {member.suffix && (
                <span className="font-normal text-slate-500 text-sm"> {member.suffix}</span>
              )}
            </h2>
            <p className="person-role">{member.role}</p>
            <div className="person-bio">
              {member.bio.map((para) => (
                <p key={para.slice(0, 40)}>{para}</p>
              ))}
            </div>
          </div>
        </article>
      ))}
    </div>
  </PublicPage>
);

export default OurTeam;
